// Why Choose Us Email Generator - Professional Trust-Building Template with Trustpilot Reviews

// Real HomeGo company images
const HOMEGO_VAN_IMAGE = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/y30jebbk_WhatsApp%20Image%202026-04-06%20at%2015.06.18.jpeg";
const HOMEGO_TEAM_INDOOR = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/fplloev3_WhatsApp%20Image%202026-04-06%20at%2014.54.11%20%283%29.jpeg";
const HOMEGO_TEAM_OUTDOOR = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/l30eg8fg_WhatsApp%20Image%202026-04-06%20at%2014.54.11%20%281%29.jpeg";
const HOMEGO_DBS_TEAM = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/0koj4d3w_IMG_6794.PNG";

// Trust partner logos
const CHECKATRADE_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/ebu7qu1u_logos-checkatrade.png";
const GETAMOVER_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/fxcpado8_download.jpg";
// Swapped - download.png is Yell (yellow), unnamed.webp is Bark (dark blue)
const BARK_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/ynl845us_download.png"; // Dark blue bark - was incorrectly labeled
const YELL_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/hs0febfn_unnamed.webp"; // Yellow Yell - was incorrectly labeled  
const TRUSTPILOT_VERIFIED_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/j8xkemf3_download-1.jpg";

// Trustpilot star SVG (inline for email compatibility)
const TRUSTPILOT_STAR = `<span style="color: #00B67A; font-size: 18px;">★</span>`;
const FIVE_STARS = `${TRUSTPILOT_STAR}${TRUSTPILOT_STAR}${TRUSTPILOT_STAR}${TRUSTPILOT_STAR}${TRUSTPILOT_STAR}`;

const generateWhyChooseUsEmailHTML = (data) => {
  const {
    customer_name = "Valued Customer",
    quotation_reference = "HG-2024-001",
    phone_number = "0330 043 4791",
    
    // Header
    company_reg_number = "16811153",
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    
    // Companies House
    companies_house_link = "https://find-and-update.company-information.service.gov.uk/company/16811153",
    
    // Hero Section
    headline = "Why Choose HomeGo Removals?",
    intro_message = "You need a team you can trust completely - one that treats your belongings like their own, arrives when promised, and makes your moving day completely stress-free.",
    
    // Our Promises
    our_promises = `We arrive on time, every time - or your money back
Your belongings handled with care and fully insured
No hidden charges - the quote we give is the price you pay
Real-time updates so you always know what's happening
Dedicated support from start to finish`,

    // Services
    economy_move_title = "Basic / Economy Move",
    economy_move_details = "Loading & unloading of your items into the van, careful transportation to your new address, placing boxes in your chosen rooms",
    economy_move_ideal = "Small moves, students, single items",
    
    comfort_move_title = "Comfort Move",
    comfort_move_details = "Everything in Economy PLUS dismantling & reassembling furniture, protective blanket wrapping for all items",
    comfort_move_ideal = "1-2 bedroom homes, couples",
    
    complete_comfort_title = "Complete Comfort Move",
    complete_comfort_details = "Everything in Comfort PLUS full professional packing service, bubble-wrap for fragiles, wardrobe boxes",
    complete_comfort_ideal = "Families, 3+ bedroom homes",
    
    premium_move_title = "Premium Move",
    premium_move_details = "Everything in Complete Comfort PLUS full unpacking service, removal of all packing materials, furniture placed exactly where you want it",
    premium_move_ideal = "Luxury homes, busy professionals",

    // Trust Section
    insurance_amount = "£50,000",
    
    // Reviews - Real testimonials
    review_1 = "Absolutely fantastic service from start to finish! The team arrived on time, were incredibly careful with our belongings, and had us completely settled into our new home by evening. Highly recommend!",
    review_1_author = "Sarah M.",
    review_1_location = "Milton Keynes → London",
    review_1_date = "March 2026",
    
    review_2 = "Used HomeGo for our office relocation. Professional, efficient, and zero downtime. The team leader kept us updated throughout. Will definitely use again for our next expansion!",
    review_2_author = "James T.",
    review_2_location = "Birmingham Office Move",
    review_2_date = "February 2026",
    
    review_3 = "Moving with two young children was stressful enough, but HomeGo made the actual move day so easy. Nothing was damaged, everything was labelled perfectly. Worth every penny!",
    review_3_author = "Emma & David K.",
    review_3_location = "Manchester → Leeds",
    review_3_date = "January 2026",
    
    review_4 = "I've used many removal companies over the years - HomeGo is by far the best. Transparent pricing, friendly team, and they genuinely care about doing a good job. 5 stars!",
    review_4_author = "Robert P.",
    review_4_location = "Bristol",
    review_4_date = "March 2026",

    // Email Links for packages
    email_subject_base = "I'd like to book",
  } = data;

  const emailBody = encodeURIComponent(`Hi ${consultant_name},

I'm interested in booking a move.

My Details:
- Name: [Your Name]
- Moving From: [Current Address]
- Moving To: [New Address]  
- Preferred Date: [Date]
- Property Size: [e.g. 2-bedroom flat]

Please contact me to discuss.

Thank you!`);

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Why Choose HomeGo Removals</title>
  <style>
    @media screen and (max-width: 620px) {
      .mobile-full { width: 100% !important; }
      .mobile-padding { padding: 15px !important; }
      .mobile-hide { display: none !important; }
      .mobile-center { text-align: center !important; }
      .mobile-stack { display: block !important; width: 100% !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: #0a0a0a; font-family: 'Segoe UI', Helvetica, Arial, sans-serif;">
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #0a0a0a;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <table border="0" cellpadding="0" cellspacing="0" width="650" style="max-width: 650px;">
          
          <!-- PREMIUM HEADER -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 16px 16px 0 0; padding: 0;">
              <!-- Top Gold Bar -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="background: linear-gradient(90deg, #D4AF37 0%, #F4D03F 50%, #D4AF37 100%); height: 4px; border-radius: 16px 16px 0 0;"></td>
                </tr>
              </table>
              
              <!-- Logo & Company Info -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="padding: 25px 30px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <h1 style="margin: 0; font-size: 32px; font-weight: 800; letter-spacing: -1px;">
                            <span style="color: #D4AF37;">Home</span><span style="color: #FFFFFF;">Go</span>
                          </h1>
                          <p style="margin: 3px 0 0; font-size: 11px; color: #D4AF37; letter-spacing: 3px; text-transform: uppercase;">Removals & Packing Ltd</p>
                        </td>
                        <td align="right" style="vertical-align: middle;">
                          <a href="${companies_house_link}" style="display: inline-block; background: linear-gradient(135deg, #10B981 0%, #059669 100%); color: #FFFFFF; font-size: 11px; font-weight: 700; text-decoration: none; padding: 10px 16px; border-radius: 25px; box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);">
                            ✓ VERIFIED COMPANY
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              <!-- Trust Bar -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="background: rgba(212, 175, 55, 0.1); border-top: 1px solid rgba(212, 175, 55, 0.2); border-bottom: 1px solid rgba(212, 175, 55, 0.2); padding: 12px 30px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="font-size: 11px; color: #D4AF37;">
                          <span style="opacity: 0.7;">🏛️</span> Reg: ${company_reg_number}
                        </td>
                        <td align="center" style="font-size: 11px; color: #D4AF37;">
                          <span style="opacity: 0.7;">🛡️</span> Insured ${insurance_amount}
                        </td>
                        <td align="right" style="font-size: 11px; color: #D4AF37;">
                          <span style="opacity: 0.7;">📞</span> ${phone_number}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- HERO SECTION WITH VAN IMAGE -->
          <tr>
            <td style="background: #ffffff; padding: 0;">
              <!-- Van Fleet Image -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="position: relative;">
                    <img src="${HOMEGO_VAN_IMAGE}" alt="HomeGo Removals Van" style="width: 100%; height: 220px; object-fit: cover; display: block;" />
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="position: relative; margin-top: -60px;">
                      <tr>
                        <td align="center">
                          <table border="0" cellpadding="0" cellspacing="0" style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); border-radius: 12px; box-shadow: 0 8px 30px rgba(0,0,0,0.3);">
                            <tr>
                              <td style="padding: 20px 40px; text-align: center;">
                                <h2 style="margin: 0; color: #000; font-size: 24px; font-weight: 800;">
                                  ${headline}
                                </h2>
                                <p style="margin: 8px 0 0; color: #1a1a1a; font-size: 13px; line-height: 1.5; max-width: 450px;">
                                  ${intro_message}
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              <!-- Greeting -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="padding: 30px 30px 20px;">
                    <p style="margin: 0; font-size: 16px; color: #333;">Dear <strong style="color: #D4AF37;">${customer_name}</strong>,</p>
                    <p style="margin: 12px 0 0; font-size: 14px; color: #666; line-height: 1.6;">
                      Thank you for considering HomeGo Removals. Here's why thousands of families across the UK trust us with their most precious belongings.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- TRUSTPILOT SECTION -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #00B67A 0%, #00A368 100%); border-radius: 12px; overflow: hidden;">
                <tr>
                  <td style="padding: 20px 25px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="vertical-align: middle;">
                          <p style="margin: 0; color: #fff; font-size: 12px; text-transform: uppercase; letter-spacing: 2px; opacity: 0.9;">Rated Excellent on</p>
                          <p style="margin: 5px 0 0; font-size: 28px; font-weight: 800; color: #fff; letter-spacing: -1px;">Trustpilot</p>
                        </td>
                        <td align="right" style="vertical-align: middle;">
                          <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="background: #fff; padding: 8px 12px; border-radius: 8px;">
                                <span style="color: #00B67A; font-size: 24px; letter-spacing: 2px;">★★★★★</span>
                              </td>
                            </tr>
                            <tr>
                              <td align="center" style="padding-top: 5px;">
                                <span style="color: #fff; font-size: 11px; font-weight: 600;">4.9 / 5.0 Rating</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- VERIFIED PARTNER BANNER - Checkatrade, Getamover, Yell, Bark, Trustpilot -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 12px; border: 2px solid #dee2e6; overflow: hidden;">
                <tr>
                  <td style="padding: 20px 25px;">
                    <!-- Header -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td align="center" style="padding-bottom: 15px;">
                          <span style="display: inline-block; background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); color: #000; font-size: 11px; font-weight: 700; padding: 8px 20px; border-radius: 25px; text-transform: uppercase; letter-spacing: 1px;">
                            ✓ APPROVED VERIFIED PARTNER
                          </span>
                        </td>
                      </tr>
                    </table>
                    
                    <!-- Row 1: 3 Logos (Checkatrade, Getamover, Trustpilot) -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <!-- Checkatrade Logo -->
                        <td width="33%" style="padding: 8px; text-align: center; vertical-align: top;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                            <tr>
                              <td style="padding: 12px; text-align: center;">
                                <img src="${CHECKATRADE_LOGO}" alt="Checkatrade Approved" style="max-width: 100px; max-height: 45px; width: auto; height: auto; display: inline-block;" />
                                <p style="margin: 8px 0 0; font-size: 10px; color: #333; font-weight: 600;">Checkatrade</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <!-- Getamover Logo -->
                        <td width="33%" style="padding: 8px; text-align: center; vertical-align: top;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                            <tr>
                              <td style="padding: 12px; text-align: center;">
                                <img src="${GETAMOVER_LOGO}" alt="Getamover Verified" style="max-width: 100px; max-height: 45px; width: auto; height: auto; display: inline-block;" />
                                <p style="margin: 8px 0 0; font-size: 10px; color: #333; font-weight: 600;">Getamover</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <!-- Trustpilot Verified Logo -->
                        <td width="33%" style="padding: 8px; text-align: center; vertical-align: top;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                            <tr>
                              <td style="padding: 12px; text-align: center;">
                                <img src="${TRUSTPILOT_VERIFIED_LOGO}" alt="Trustpilot Verified Reviews" style="max-width: 100px; max-height: 45px; width: auto; height: auto; display: inline-block;" />
                                <p style="margin: 8px 0 0; font-size: 10px; color: #333; font-weight: 600;">Trustpilot</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                    
                    <!-- Row 2: 2 Logos (Yell, Bark) - Centered -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td width="16%"></td>
                        <!-- Yell.com Logo -->
                        <td width="33%" style="padding: 8px; text-align: center; vertical-align: top;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                            <tr>
                              <td style="padding: 12px; text-align: center;">
                                <img src="${YELL_LOGO}" alt="Yell.com Verified" style="max-width: 100px; max-height: 45px; width: auto; height: auto; display: inline-block;" />
                                <p style="margin: 8px 0 0; font-size: 10px; color: #333; font-weight: 600;">Yell.com</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <!-- Bark.com Logo -->
                        <td width="33%" style="padding: 8px; text-align: center; vertical-align: top;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                            <tr>
                              <td style="padding: 12px; text-align: center;">
                                <img src="${BARK_LOGO}" alt="Bark.com Verified" style="max-width: 100px; max-height: 45px; width: auto; height: auto; display: inline-block;" />
                                <p style="margin: 8px 0 0; font-size: 10px; color: #333; font-weight: 600;">Bark.com</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td width="16%"></td>
                      </tr>
                    </table>
                    
                    <!-- Trust Message -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td align="center" style="padding-top: 15px;">
                          <p style="margin: 0; font-size: 12px; color: #555; line-height: 1.5; max-width: 450px;">
                            HomeGo Removals is proudly verified by the UK's leading trade review platforms. Your move is in trusted, vetted hands.
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- OUR PROMISES -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 12px; overflow: hidden;">
                <tr>
                  <td style="padding: 25px;">
                    <h3 style="margin: 0 0 18px; font-size: 18px; font-weight: 700; color: #D4AF37; text-align: center; letter-spacing: 1px;">
                      🤝 OUR PROMISES TO YOU
                    </h3>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      ${our_promises.split('\n').filter(p => p.trim()).map(promise => `
                        <tr>
                          <td style="padding: 8px 0;">
                            <table border="0" cellpadding="0" cellspacing="0">
                              <tr>
                                <td style="vertical-align: top; padding-right: 12px;">
                                  <span style="display: inline-block; width: 22px; height: 22px; background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); border-radius: 50%; text-align: center; line-height: 22px; font-size: 12px; color: #000;">✓</span>
                                </td>
                                <td style="font-size: 14px; color: #ffffff; line-height: 1.5;">${promise.trim()}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      `).join('')}
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- CUSTOMER REVIEWS -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <h3 style="margin: 0 0 18px; font-size: 20px; font-weight: 700; color: #1a1a1a; text-align: center;">
                💬 What Our Customers Say
              </h3>
              
              <!-- Review 1 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; margin-bottom: 12px; border-left: 4px solid #00B67A;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="color: #00B67A; font-size: 16px; letter-spacing: 1px;">★★★★★</span>
                        </td>
                        <td align="right">
                          <span style="font-size: 11px; color: #999;">${review_1_date}</span>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 10px 0; font-size: 13px; color: #444; line-height: 1.6; font-style: italic;">"${review_1}"</p>
                    <p style="margin: 0; font-size: 12px; color: #666;">
                      <strong style="color: #1a1a1a;">${review_1_author}</strong> 
                      <span style="opacity: 0.7;">• ${review_1_location}</span>
                    </p>
                  </td>
                </tr>
              </table>
              
              <!-- Review 2 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; margin-bottom: 12px; border-left: 4px solid #00B67A;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="color: #00B67A; font-size: 16px; letter-spacing: 1px;">★★★★★</span>
                        </td>
                        <td align="right">
                          <span style="font-size: 11px; color: #999;">${review_2_date}</span>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 10px 0; font-size: 13px; color: #444; line-height: 1.6; font-style: italic;">"${review_2}"</p>
                    <p style="margin: 0; font-size: 12px; color: #666;">
                      <strong style="color: #1a1a1a;">${review_2_author}</strong> 
                      <span style="opacity: 0.7;">• ${review_2_location}</span>
                    </p>
                  </td>
                </tr>
              </table>
              
              <!-- Review 3 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; margin-bottom: 12px; border-left: 4px solid #00B67A;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="color: #00B67A; font-size: 16px; letter-spacing: 1px;">★★★★★</span>
                        </td>
                        <td align="right">
                          <span style="font-size: 11px; color: #999;">${review_3_date}</span>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 10px 0; font-size: 13px; color: #444; line-height: 1.6; font-style: italic;">"${review_3}"</p>
                    <p style="margin: 0; font-size: 12px; color: #666;">
                      <strong style="color: #1a1a1a;">${review_3_author}</strong> 
                      <span style="opacity: 0.7;">• ${review_3_location}</span>
                    </p>
                  </td>
                </tr>
              </table>
              
              <!-- Review 4 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; border-left: 4px solid #00B67A;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="color: #00B67A; font-size: 16px; letter-spacing: 1px;">★★★★★</span>
                        </td>
                        <td align="right">
                          <span style="font-size: 11px; color: #999;">${review_4_date}</span>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 10px 0; font-size: 13px; color: #444; line-height: 1.6; font-style: italic;">"${review_4}"</p>
                    <p style="margin: 0; font-size: 12px; color: #666;">
                      <strong style="color: #1a1a1a;">${review_4_author}</strong> 
                      <span style="opacity: 0.7;">• ${review_4_location}</span>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- DBS APPROVED TEAM SECTION -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 16px; overflow: hidden;">
                <tr>
                  <td>
                    <img src="${HOMEGO_DBS_TEAM}" alt="HomeGo DBS Approved Team" style="width: 100%; height: 280px; object-fit: cover; display: block;" />
                  </td>
                </tr>
                <tr>
                  <td style="padding: 20px; text-align: center;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td align="center">
                          <span style="display: inline-block; background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); color: #000; font-size: 11px; font-weight: 700; padding: 8px 20px; border-radius: 25px; text-transform: uppercase; letter-spacing: 1px;">
                            🛡️ DBS APPROVED • TRUSTED MOVERS • VERIFIED CREW
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding-top: 12px;">
                          <p style="margin: 0; font-size: 14px; color: #ccc; line-height: 1.6;">
                            Every member of our team is DBS checked and verified. Your home and belongings are in safe, trusted hands.
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- OUR TEAM IN ACTION -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <h3 style="margin: 0 0 18px; font-size: 20px; font-weight: 700; color: #1a1a1a; text-align: center;">
                👷 Our Professional Team in Action
              </h3>
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td width="50%" style="padding-right: 8px; vertical-align: top;">
                    <img src="${HOMEGO_TEAM_INDOOR}" alt="HomeGo Team Careful Handling" style="width: 100%; height: 150px; object-fit: cover; border-radius: 12px; display: block;" />
                    <p style="margin: 10px 0 0; font-size: 12px; color: #666; text-align: center; font-weight: 600;">🛋️ Careful Furniture Handling</p>
                  </td>
                  <td width="50%" style="padding-left: 8px; vertical-align: top;">
                    <img src="${HOMEGO_TEAM_OUTDOOR}" alt="HomeGo Team Professional Service" style="width: 100%; height: 150px; object-fit: cover; border-radius: 12px; display: block;" />
                    <p style="margin: 10px 0 0; font-size: 12px; color: #666; text-align: center; font-weight: 600;">📦 Professional Equipment</p>
                  </td>
                </tr>
              </table>
              <p style="margin: 15px 0 0; font-size: 13px; color: #555; text-align: center; line-height: 1.5;">
                Our trained team uses protective blankets, straps, and professional equipment to ensure your belongings arrive safely.
              </p>
            </td>
          </tr>
          
          <!-- SERVICES SECTION -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 25px;">
              <h3 style="margin: 0 0 18px; font-size: 20px; font-weight: 700; color: #1a1a1a; text-align: center;">
                📦 Our Service Packages
              </h3>
              <p style="margin: 0 0 15px; font-size: 13px; color: #666; text-align: center;">Choose the perfect package for your move</p>
              
              <!-- Economy Package -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; margin-bottom: 12px;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="background: #6B7280; color: #fff; font-size: 9px; font-weight: 700; padding: 4px 10px; border-radius: 12px; text-transform: uppercase;">Budget-Friendly</span>
                        </td>
                        <td align="right">
                          <a href="mailto:office@homego-removals.com?subject=${encodeURIComponent(email_subject_base + ' - ' + economy_move_title)}&body=${emailBody}" style="background: linear-gradient(135deg, #1a1a1a 0%, #333 100%); color: #fff; font-size: 11px; font-weight: 600; text-decoration: none; padding: 8px 16px; border-radius: 20px;">
                            Choose →
                          </a>
                        </td>
                      </tr>
                    </table>
                    <h4 style="margin: 12px 0 6px; font-size: 16px; font-weight: 700; color: #1a1a1a;">📦 ${economy_move_title}</h4>
                    <p style="margin: 0 0 8px; font-size: 13px; color: #555; line-height: 1.5;">${economy_move_details}</p>
                    <p style="margin: 0; font-size: 12px; color: #10B981; font-weight: 600;">✓ Perfect for: ${economy_move_ideal}</p>
                  </td>
                </tr>
              </table>
              
              <!-- Comfort Package (Featured) -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%); border-radius: 12px; margin-bottom: 12px; border: 2px solid #D4AF37;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); color: #000; font-size: 9px; font-weight: 700; padding: 4px 10px; border-radius: 12px; text-transform: uppercase;">⭐ Recommended</span>
                        </td>
                        <td align="right">
                          <a href="mailto:office@homego-removals.com?subject=${encodeURIComponent(email_subject_base + ' - ' + comfort_move_title)}&body=${emailBody}" style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); color: #000; font-size: 11px; font-weight: 700; text-decoration: none; padding: 8px 16px; border-radius: 20px;">
                            Choose →
                          </a>
                        </td>
                      </tr>
                    </table>
                    <h4 style="margin: 12px 0 6px; font-size: 16px; font-weight: 700; color: #1a1a1a;">🛋️ ${comfort_move_title}</h4>
                    <p style="margin: 0 0 8px; font-size: 13px; color: #555; line-height: 1.5;">${comfort_move_details}</p>
                    <p style="margin: 0; font-size: 12px; color: #10B981; font-weight: 600;">✓ Perfect for: ${comfort_move_ideal}</p>
                  </td>
                </tr>
              </table>
              
              <!-- Complete Comfort Package -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%); border-radius: 12px; margin-bottom: 12px; border: 2px solid #3B82F6;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); color: #fff; font-size: 9px; font-weight: 700; padding: 4px 10px; border-radius: 12px; text-transform: uppercase;">🔥 Most Popular</span>
                        </td>
                        <td align="right">
                          <a href="mailto:office@homego-removals.com?subject=${encodeURIComponent(email_subject_base + ' - ' + complete_comfort_title)}&body=${emailBody}" style="background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); color: #fff; font-size: 11px; font-weight: 600; text-decoration: none; padding: 8px 16px; border-radius: 20px;">
                            Choose →
                          </a>
                        </td>
                      </tr>
                    </table>
                    <h4 style="margin: 12px 0 6px; font-size: 16px; font-weight: 700; color: #1a1a1a;">🏠 ${complete_comfort_title}</h4>
                    <p style="margin: 0 0 8px; font-size: 13px; color: #555; line-height: 1.5;">${complete_comfort_details}</p>
                    <p style="margin: 0; font-size: 12px; color: #10B981; font-weight: 600;">✓ Perfect for: ${complete_comfort_ideal}</p>
                  </td>
                </tr>
              </table>
              
              <!-- Premium Package -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 12px; border: 2px solid #D4AF37;">
                <tr>
                  <td style="padding: 18px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); color: #000; font-size: 9px; font-weight: 700; padding: 4px 10px; border-radius: 12px; text-transform: uppercase;">👑 Premium</span>
                        </td>
                        <td align="right">
                          <a href="mailto:office@homego-removals.com?subject=${encodeURIComponent(email_subject_base + ' - ' + premium_move_title)}&body=${emailBody}" style="background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); color: #000; font-size: 11px; font-weight: 700; text-decoration: none; padding: 8px 16px; border-radius: 20px;">
                            Choose →
                          </a>
                        </td>
                      </tr>
                    </table>
                    <h4 style="margin: 12px 0 6px; font-size: 16px; font-weight: 700; color: #D4AF37;">✨ ${premium_move_title}</h4>
                    <p style="margin: 0 0 8px; font-size: 13px; color: #ccc; line-height: 1.5;">${premium_move_details}</p>
                    <p style="margin: 0; font-size: 12px; color: #10B981; font-weight: 600;">✓ Perfect for: ${premium_move_ideal}</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- CTA SECTION -->
          <tr>
            <td style="background: #ffffff; padding: 0 30px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); border-radius: 12px;">
                <tr>
                  <td style="padding: 30px; text-align: center;">
                    <h3 style="margin: 0 0 10px; font-size: 22px; font-weight: 800; color: #000;">Ready to Book Your Move?</h3>
                    <p style="margin: 0 0 20px; font-size: 14px; color: #333;">Get a free quote today - no obligation!</p>
                    <a href="tel:${phone_number.replace(/\s/g, '')}" style="display: inline-block; background: #000; color: #D4AF37; font-size: 16px; font-weight: 700; text-decoration: none; padding: 14px 40px; border-radius: 30px; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
                      📞 Call ${phone_number}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>


          
          <!-- FOOTER -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 0 0 16px 16px; padding: 25px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <p style="margin: 0 0 5px; font-size: 14px; font-weight: 700;">
                      <span style="color: #D4AF37;">Home</span><span style="color: #fff;">Go</span>
                      <span style="color: #666; font-weight: 400;"> Removals & Packing Ltd</span>
                    </p>
                    <p style="margin: 0 0 15px; font-size: 11px; color: #888;">
                      Company Reg: ${company_reg_number} | Fully Insured | ${insurance_amount} Cover
                    </p>
                    <p style="margin: 0; font-size: 12px; color: #D4AF37;">
                      📞 ${phone_number} | 📧 office@homego-removals.com
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;
};

export default generateWhyChooseUsEmailHTML;
